import { PrimaryButton } from '@designsforhealth/dfh-react-components'
import React, { FC } from 'react'
import styled from 'styled-components'

const GridButtonContainer = styled.div`
  width: 100%;
  @media (min-width: 600px) {
    width: 80%;
  }
  @media (min-width: 960px) {
    width: 70%;
  }
  @media (min-width: 1280px) {
    width: 50%;
  }
`

const Button = styled(PrimaryButton)`
  --btn-line-height: 19px;
  width: 100%;

  &:disabled {
    pointer-events: none;
  }
`

interface GridButtonProps {
  id?: string
  type?: 'button' | 'submit' | 'reset'
  disabled?: boolean
  className?: string
  onClick?: React.MouseEventHandler<HTMLButtonElement>
}

export const GridButton: FC<GridButtonProps> = ({
  id,
  children,
  type = 'button',
  disabled = false,
  className = '',
  onClick,
}) => {
  return (
    <GridButtonContainer>
      <Button className={className} type={type} id={id} disabled={disabled} onClick={onClick}>
        {children}
      </Button>
    </GridButtonContainer>
  )
}
